import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { FontAwesomeIcon } from "../../libs/fonts"

import NewsletterForm from "../NewsletterForm/NewsletterForm";

const DefaultFooter = () => (
  // TODO
  <></>
);

const Footer = () => {
  const footerQuery = useStaticQuery(graphql`
    query {
      allBuilderModels {
        oneFooter(
          options: {
            limit: 1
            cachebust: true
          }
        ) {
          content
        }
      }
    }
  `);

  const data = footerQuery?.allBuilderModels?.oneFooter?.content?.data;

  if (!data) {
    return DefaultFooter;
  }

  const { logo, links, socials, newsletterForm } = data;

  const filteredLinks = links.filter(({ hide }) => !hide);
  const filteredSocials = socials.filter(({ hide }) => !hide);

  return (
    <footer id="rs-footer" className="rs-footer style1 footer-home6-style mt-120">
      <div className="footer-top">
        <div className="container">
          <div className='row'>
            <ul className='mb-60 footer-links'>
              {!!filteredLinks?.length && filteredLinks.map(({ url, text }, i) => (
                <li key={`${url}-${i}`}  className="pr-45 pb-14">
                  {url.startsWith('http') ? (
                    <a href={url} target='_blank' rel='noreferrer'>{text}</a>
                  ) : (
                    <Link to={url}>{text}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="row">
            <div className="col-lg-2 col-md-12 col-sm-12 md-mb-10">
              <div className="footer-logo mb-40">
                <Link to="/">
                  <img
                    src={logo}
                    alt="CommCon"
                    style={{ height: 40, width: 33 }}
                  />
                </Link>
              </div>
            </div>
            <div className="col-lg-10">
              <div className="row">
                <div className="col-lg-8 col-md-12 col-sm-12 md-mb-10 pl-90 md-pl-15">
                  {newsletterForm ? (
                    <NewsletterForm
                      title={newsletterForm.title}
                      mailchimpUrl={newsletterForm.mailchimpUrl}
                      mailchimpTag={newsletterForm.mailchimpTag}
                      firstNamePlaceholder={newsletterForm.firstNamePlaceholder}
                      lastNamePlaceholder={newsletterForm.lastNamePlaceholder}
                      emailPlaceholder={newsletterForm.emailPlaceholder}
                      buttonText={newsletterForm.buttonText}
                      minimise={true}
                    />
                  ) : (
                    <>
                      <h3 className="footer-title">Email us</h3>
                      <div className="textwidget">
                        <a href="mailto:hello@commcon.xyz">hello@commcon.xyz</a><br />
                      </div>
                    </>
                  )}
                </div>

                {!!filteredSocials.length && (
                  <div className="col-lg-4 col-md-12 col-sm-12 pl-115 md-pl-15">
                    <h3 className="footer-title">Follow Us</h3>
                    <ul className="footer-social">
                      {filteredSocials.map(({ network, url }, i) => (
                        <li key={`${network}-${i}`}>
                          <a href={url} target='_blank' rel='noreferrer'>
                            <FontAwesomeIcon icon = {`fa-brands fa-${network}`} style={{ color: 'black' }} />
                            <span style={{ display: 'none' }}>{network} link</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="row y-middle">
            <div className="col-lg-6">
              <div className="copyright text-lg-start text-center ">
                <p>© 2024 CommCon Events Ltd, All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
